import React from 'react'
import TemplateCom3 from '../Component/TemplateCom3'

const Template3 = () => {
  return (
    <TemplateCom3/>
  )
}

export default Template3